import { useEffect, useState } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";

export const useHeaderSearch = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState(searchParams.get("q") || "");
  const [searchType, setSearchType] = useState(
    searchParams.get("type") || "players"
  );
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // Marin 2026-08-24: the typed query must not stick forever. ON the results
  // page the field keeps showing the active search (his 2026-08-13 rule) and
  // re-syncs from ?q= so browser back/forward stays truthful; the moment the
  // user LEAVES /search (profile pages under /search/... included), field and
  // type reset. Deliberately keyed on the pathname only — while staying on
  // /search nothing may wipe what the user is typing.
  useEffect(() => {
    if (location.pathname === "/search") {
      setSearchQuery(searchParams.get("q") || "");
      setSearchType(searchParams.get("type") || "players");
    } else {
      setSearchQuery("");
      setSearchType("players");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // Returns whether it actually searched, so a caller can react to that —
  // the mobile overlay uses it to close itself only once results exist.
  const handleSearch = (e) => {
    e.preventDefault();
    if (!searchQuery.trim()) return false;

    const params = new URLSearchParams({
      q: searchQuery,
      type: searchType,
    });
    navigate(`/search?${params.toString()}`);
    // Deliberately NOT clearing the input: the header pill is the ONLY search
    // field the /search page has, so wiping it here made the just-searched
    // query invisible (Marin, Staging-Abnahme 2026-08-13). The URL keeps ?q=
    // and the field keeps the text the results belong to.
    return true;
  };

  const searchTypes = [
    { value: "players", label: "Players" },
    { value: "agents", label: "Agents" },
    { value: "agencies", label: "Agencies" },
    { value: "staff", label: "Staff" },
    { value: "clubs", label: "Clubs" },
    { value: "coaches", label: "Coaches" },
    // Competitions (TP-CompetitionPage build): served by /dashboard/search/
    // type=competitions (BE build in flight); results render in SearchTable's
    // competitions branch.
    { value: "competitions", label: "Competitions" },
  ];

  return {
    searchQuery,
    setSearchQuery,
    searchType,
    setSearchType,
    isSearchOpen,
    setIsSearchOpen,
    handleSearch,
    searchTypes,
  };
};
